import { Box } from "@mui/material";
import React, { useMemo, useState } from "react";
import { ActiveItemInterface, TextSuiteSidebar } from "./TextSuiteSidebar";
import { TextSuitesBody } from "../Components/TextSuitesBody";
import {
  SuitesApps,
  TextSuiteApps,
  TextSuitesApps,
  TextSuiteType,
} from "../../../Helper";
import { HumanizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/HumanizeIcon";
import { ParaphraseIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ParaphraseIcon";
import { AIDetectorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/AIDetectorIcon";
import { TitleGeneratorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TitleGeneratorIcon";
import { SummarizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/SummarizeIcon";
import { TranslatorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TranslatorIcon";
import { PromptEngineerIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/PromptEngineerIcon";
import "../../SharedSuite/Suites.css";
import { ImageTranscaptionIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageTranscaptionIcon";
import { ImageToPromptIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageToPromptIcon";
export const TextSuitesNavbarApps = [
  {
    title: TextSuiteApps.Translator,
    icon: <TranslatorIcon className="text-nav-item-icon" />,
    type: 0,
  },
  {
    title: TextSuiteApps.Humanizer,
    icon: <HumanizeIcon className="text-nav-item-icon-stroke" />,
    type: TextSuiteType.Translator,
  },
  {
    title: TextSuiteApps.Summarizer,
    icon: <SummarizeIcon className="text-nav-item-icon" />,
    type: 2,
  },
  {
    title: TextSuiteApps.Paraphraser,
    icon: <ParaphraseIcon className="text-nav-item-icon" />,
    type: TextSuiteType.Paraphraser,
  },
  {
    title: TextSuiteApps.TitleGenerator,
    icon: <TitleGeneratorIcon className="text-nav-item-icon" />,
    type: TextSuiteType.TitleGenerator,
  },
  {
    title: TextSuiteApps.PromptGenerator,
    icon: <PromptEngineerIcon className="text-nav-item-icon" />,
    type: TextSuiteType.PromptGenerator,
  },
  {
    title: TextSuiteApps.TextExtraction,
    icon: <ImageTranscaptionIcon className="text-nav-item-icon" />,
    type: TextSuiteType.TextExtraction,
  },
  {
    title: TextSuiteApps.ImageToPrompt,
    icon: <ImageToPromptIcon className="text-nav-item-icon" />,
    type: TextSuiteType.ImageToPrompt,
  },
];

export const GetTextAppObject = (title: string) => {
  const appObject = TextSuitesNavbarApps.find((app) => app.title === title);
  return appObject;
};

export const TextSuites = () => {
  const [inputValue, setInputValue] = useState("");
  const [outputValue, setOutputValue] = useState("");
  const [activeItem, setActiveItem] = useState<ActiveItemInterface>({
    title: "",
    icon: <></>,
    type: 0,
  });
  const [selectedFromDropdownItem, setSelectedFromDropdownItem] = useState("");
  const [selectedToDropdownItem, setSelectedToDropdownItem] =
    useState("English");

  // Get active app data.
  const activeItemData = useMemo(() => {
    const appDetails = TextSuitesApps.find(
      (app) => app.appTitle === activeItem.title
    );
    setSelectedFromDropdownItem(appDetails?.defaultSelectorOption || "");
    return appDetails;
  }, [activeItem]);

  return (
    <Box className="text-suites-view">
      <TextSuiteSidebar
        setActiveItem={setActiveItem}
        activeItem={activeItem}
        setSelectedFromDropdownItem={setSelectedFromDropdownItem}
        setSelectedToDropdownItem={setSelectedToDropdownItem}
        setInputValue={setInputValue}
        TextSuitesApps={TextSuitesNavbarApps}
      />
      <TextSuitesBody
        activeItem={activeItem}
        setSelectedFromDropdownItem={setSelectedFromDropdownItem}
        setSelectedToDropdownItem={setSelectedToDropdownItem}
        selectedFromDropdownItem={selectedFromDropdownItem}
        selectedToDropdownItem={selectedToDropdownItem}
        activeItemData={activeItemData}
        setInputValue={setInputValue}
        setOutputValue={setOutputValue}
        inputValue={inputValue}
        outputValue={outputValue}
        sourceWorkflow={"TextSuites"}
      />
    </Box>
  );
};
